import { parseDate } from "data/lib/dates"
// Data
import notificationService from 'data/notification'
import propertyReportService from "data/reports-property"
import underwritingService from "data/underwriting"
import _ from 'lodash'
import calcService from "data/calc"
import Moment from 'moment'
import React, { FC, useEffect, useState } from "react"
// Styles
import { ButtonWithPress_s, Label_s } from "styles/app-styles"
import { DateText_s, ReportForm_s } from "styles/report-styles"

interface WALTProps {
  property: object
}

const WALTReport: FC<WALTProps> = (props) => {
  const [as_of_date, setDate] = useState<string>(underwritingService.getReportBeginDefault(true, null, true))

  function submit():void {
    propertyReportService.propertyReport({
      report: 'weighted_average_lease_term',
      params: {
        as_of_date: parseDate(as_of_date).format('MM/DD/YYYY')
      }
    });
  }

  useEffect(() => {
    const analysisBegin = Moment(props.property['analysisbegindate']);
    let date:any = as_of_date;
    if (parseDate(date).isBefore(parseDate(analysisBegin))){
      date = analysisBegin;
      notificationService.notify({
        type: "warn",
        message: 'Report Begin Date adjusted to earliest possible date, the Analysis Begin',
        dismiss: 5000
      })
      setDate(date)
    }
  }, [as_of_date])

  const disabled = !calcService.calcCheck(props.property)
  const buttonText = disabled ? 'Calculation Required' : 'Run Report'

  return (
    <div>
      <ButtonWithPress_s primary onClick={submit} style={{marginBottom: 20}} disabled={disabled}>{buttonText}</ButtonWithPress_s>
      <ReportForm_s>
        <div>
          <Label_s>Start Date</Label_s>
          <DateText_s withoutDays value={parseDate(as_of_date).format('MM/DD/YYYY')} onChange={setDate} onBlur={setDate} persist={setDate} />
        </div>
      </ReportForm_s>
    </div>
  )
}

export default WALTReport
